import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import HeroLayout from 'components/UI/HeroLayout';
import SearchBar from 'components/UI/SearchBar';
import React, { createContext, useContext, useState } from 'react';
import { StoreContext } from 'utilities/StoreContextWrapper';
import { useMediaQ } from 'utilities/useMediaQ';
import Card from './components/Card';
import Maps from './components/Maps';
import './index.modules.scss';

export const OverOrionContext = createContext(null);

const CardItem = (school) => (
    <Card
        image={school?.image}
        logo={school?.logo}
        name={school?.name}
        contact={school?.contact}
        index={school?.index}
        subDivisions={school?.subdivisions}
        key={school?.id}
        id={school?.id}
        popup={school?.popup}
    />
);

export default function OverOrion() {
    const [searchValue, setSearchValue] = useState('');
    const query = useMediaQ('min', 1100);
    const [selected, setSelected] = useState(0);

    const { schoolGroups } = useContext(StoreContext);

    let counter = 0;

    const schoolsWithIndex = schoolGroups
        .filter((schoolGroup) => schoolGroup.hide_from_contact === 0)
        .map((schoolGroup, index) => {
            if (schoolGroup?.schools.length === 0) {
                counter += 1;
            }

            return schoolGroup?.schools.length > 0
                ? {
                      ...schoolGroup,
                      subdivisions: schoolGroup?.schools.map((s, i) => {
                          counter += 1;
                          return {
                              ...s,
                              index: counter,
                          };
                      }),
                  }
                : { ...schoolGroup, index: counter };
        });

    const filteredSchools = schoolsWithIndex?.filter((school) =>
        searchValue
            ? school?.name.toLowerCase().includes(searchValue?.toLowerCase())
            : true
    );

    return (
        <OverOrionContext.Provider value={{ selected, setSelected }}>
            <Layout>
                <Container>
                    <HeroLayout>
                        <div styleName="grid">
                            <div styleName="sticky-wrapper">
                                <div styleName="sticky">
                                    <SearchBar
                                        searchValue={searchValue}
                                        setSearchValue={setSearchValue}
                                    />
                                    <Maps schools={filteredSchools} />
                                </div>
                            </div>
                            {query ? (
                                <div styleName="schools-2-columns">
                                    <div styleName="left">
                                        {filteredSchools
                                            .filter((e, i) => i % 2 === 0)
                                            .map((school) => CardItem(school))}
                                    </div>
                                    <div styleName="right">
                                        {filteredSchools
                                            .filter((e, i) => i % 2 === 1)
                                            .map((school) => CardItem(school))}
                                    </div>
                                </div>
                            ) : (
                                <div styleName="schools">
                                    {filteredSchools.map((school) =>
                                        CardItem(school)
                                    )}
                                </div>
                            )}
                        </div>
                    </HeroLayout>
                </Container>
            </Layout>
        </OverOrionContext.Provider>
    );
}
